import React from 'react';

import Layout from '../../../components/Layout/Layout';
import messages from '../../../locale/jsonMessages';
import ServicePlansReturnPayment from './ServicePlansReturnPayment';

export default function action({ store, params, intl }) {

    const title = intl?.formatMessage(messages.reviewAndPayLabel);
    const isAuthenticated = store.getState().runtime.isAuthenticated;
    let id = params?.id

    if (!isAuthenticated) return { redirect: '/login' };

    return {
        title,
        component:
            <Layout>
                <ServicePlansReturnPayment id={id} />
            </Layout>,

    };
}
